/** A validated consent status landing never restores the opener's shared session. */
export function isCalendarAuthorizationReturn(): boolean {
  const query = new URLSearchParams(window.location.search);
  return (
    ["/settings", "/settings/account"].includes(window.location.pathname) &&
    query.get("calendar_popup") === "1" &&
    ["connected", "reconnect", "use_existing"].includes(
      query.get("calendar") ?? "",
    )
  );
}

/** Only a status crosses the window boundary; the parent reads owned server state. */
export function relayCalendarAuthorizationReturn(): void {
  if (!isCalendarAuthorizationReturn() || !window.opener) return;
  const status = new URLSearchParams(window.location.search).get("calendar");
  window.opener.postMessage(
    { type: "starling-calendar-oauth", status },
    window.location.origin,
  );
  window.close();
}
